// ENIRONMENT SPECIFIC
export const ROUTE = 'priseenenterprise';
export const REGION_KEY = process.env.REACT_APP_REGION_KEY;
export const APP_KEY = process.env.REACT_APP_PMTR_APP_KEY;
export const API_KEY = process.env.REACT_APP_API_KEY;

export const HOST = process.env.REACT_APP_BACKEND_BASE_URL;
const NGROK_HOST = 'https://5f7d722afb45.ngrok-free.app/api';
// export const HOST = NGROK_HOST;
export const MEDIA_BASE_URL = 'https://basestoragen1.blob.core.windows.net/lcache';
export const ICONS_BASE_URL = 'https://basestoragen1.blob.core.windows.net/gpublic/icons';
const PRISEEN_BUSINESS_BACKEND = 'https://dev-prsn-be-n1-ambbg3d0ducsbbd8.uaenorth-01.azurewebsites.net/api';
export const PRISEEN_NGROK = 'https://a11e11aa9eb5.ngrok-free.app/api';
// export const PRISEEN_CUST_HOST = PRISEEN_NGROK;
export const PRISEEN_CUST_HOST = process.env.REACT_APP_PRISEEN_CUST_HOST;

export const PRISEEN_PUBLIC_USER = '1d813a670d3e907d3a9d634dca726fbb';
export const PRISEEN_HOST = PRISEEN_BUSINESS_BACKEND;

export const SYSTEM_HOST = process.env.REACT_APP_BACKEND_SYSTEM_URL;

export const SOCKET_URL = 'wss://priseenbedev.azurewebsites.net/server';

export const PASS_KEY = 'Mb2fjSrWsexYELJtT#Pm6q8VKXFHR~hkZDvgpz4w9Gua5Udc3QnyX^X';

export const LOGIN_URL = `${HOST}/accounts/login`;

// export const PMTR_LOGIN_URL = `${HOST}/accounts/r/vaseelahae/login`;
export const PMTR_LOGIN_URL = `${HOST}/accounts/r/${REGION_KEY}/login`;
// export const PMTR_LOGIN_URL = `${HOST}/accounts/r/cacheenterprise/login`;
export const PRISEEN_LOGIN_URL = `${PRISEEN_HOST}/accounts/login`;
export const FORGOT_PASSWORD_URL = `${HOST}/accounts/user/forget_password`;

// REGISTRATION
export const INIT_REG_URL = `${HOST}/accounts/b/enterprise/${REGION_KEY}/registration/initialize`;
export const REGISTER_URL = `${HOST}/accounts/b/enterprise/${REGION_KEY}/registration/process`;

// OTHERS
export const CONT_LICENSE = '8094801875318848';

export const PMTR_PRSN_URL = `${HOST}/ext/priseen/sme/${APP_KEY}`;
export const PMTR_PRSN_SME_SETUP_URL = `${HOST}/ext/priseen/setup/sme/${APP_KEY}`;

// URIS
export const ACCOUNTS_URI = '/accounts';
export const USER_URI = '/user';
export const PROFILE_URI = '/profile';
export const LOGIN_URI = '/login';
export const REGISTER_URI = '/register';
export const LOCATION_URI = '/location';
export const BUSINESS_URI = '/business';
export const BACKOFFICE_URI = '/backoffice';
export const STORE_URI = '/store';
export const ITEM_URI = '/item';
export const ITEMS_URI = '/items';
export const LIST_URI = '/list';
export const LIST_ITEMS = '/listitems';
export const HIERARCHY_URI = '/hierarchy';
export const HIER_URI = '/hier';
export const MAINTAIN_URI = '/maintain';
export const UPLOAD_URI = '/upload';
export const ZONES_URI = '/zones';
export const ZONE_URI = '/zone';
export const SUPPLIERS_URI = '/suppliers';
export const SUPPLIER_URI = '/supplier';
export const MANAGE_URI = '/manage';
export const CREATE_URI = '/create';
export const PRICE_URI = '/price';
export const PRICES_URI = '/prices';
export const CODE_URI = '/code';
export const CODES_URI = '/codes';
export const REUDCTIONS_URI = '/reductions';
export const REDUCTIONS_URI = '/reductions';
export const REDUCTION_URI = '/reduction';
export const PROMOTION_URI = '/promotion';
export const PROMOTIONS_URI = '/promotions';
export const PROMO_URI = '/promo';
export const F_URI = '/f';
export const A_URI = '/a';
export const L_URI = '/l';
export const VERIFYCODE_URI = '/verifycode';
export const OFFERS_URI = '/offers';
export const ALLOC_URI = '/alloc';
export const CAMPAINGS_URI = '/campaigns';
export const GETLIST_URI = '/getlist';
export const PROC_URI = '/proc';
export const ERRORS_URI = '/errors';
export const SUBMIT_URI = '/submit';
export const SPECS_URI = '/specs';
export const GROUP_URI = '/group';
export const MAP_URI = '/map';
export const CATALOG_URI = '/catalog';
export const CATALOGUE_URI = '/catalogue';
export const CATALOGUES_URI = '/catalogues';
export const EXECUTE_JOBS_URI = '/execute-job';
export const JOBS_URI = '/jobs';
export const DOCUMENT_GROUP_URI = '/documentgroup';
export const DOCGROUP_URI = '/docgroup';
export const DOCUMENT_GROUPS_URI = '/documentgroups';
export const INTERNAL_URI = '/internal';
export const FETCH_COORDS_URI = '/fetchcoordinates';
export const LOCS_URI = '/locs';
export const FETCH_PLACES_URI = '/fetchplaces';
export const DELETE_URI = '/delete';
export const UPDATE_URI = '/update';
export const MENU_URI = '/menu';
export const TAGS_URI = '/tags';
export const CATEGORIES_URI = '/categories';
export const RECIPE_URI = '/recipe';
export const RECIPES_URI = '/recipes';
export const DONATIONS_URI = '/donations';
export const PROGRAMS_URI = '/programs';
export const REQUEST_URI = '/request';
export const REQUESTS_URI = '/requests';
export const ADMIN_URI = '/admin';
export const BENEFICIARY_URI = '/beneficiary';
export const INGREDIENTS_URL = HOST + BACKOFFICE_URI + '/ingredients';

// Dropdown data
export const USER_TYPES = [
  { name: 'Supplier', value: 'S' },
  { name: 'Retailer', value: 'B' },
  { name: 'Admin', value: 'A' }
];

// ROLES
export const ROLES = {
  Retailer: 'B',
  // Operations: 'O',
  // Consumer: 'C',
  Supplier: 'S',
  Admin: 'A'
};

export const PRISEEN_USER_TYPES = [
  {
    id: 5,
    user_type: 'Admin'
  },
  {
    id: 6,
    user_type: 'Manager'
  },
  {
    id: 7,
    user_type: 'Employee'
  }
];

export const LANGUAGES = [
  { code: 'en_US', name: 'English', nativeName: 'English', country: 'United States', flag: 'US' },
  { code: 'ar_AE', name: 'Arabic', nativeName: 'العربية', country: 'United Arab Emirates', flag: 'AE' },
  { code: 'ur_PK', name: 'Urdu', nativeName: 'اُردُو', country: 'Pakistan', flag: 'PK' },
  { code: 'hi_IN', name: 'Hindi', nativeName: 'हिन्दी', country: 'India', flag: 'IN' }
];

export const SUPPORTED_LANGUAGES = [
  { value: 'en', name: 'English', country: 'United States', flag: 'US' },
  { value: 'ar', name: 'العربية', country: 'United Arab Emirates', flag: 'AE' },
  { value: 'ur', name: 'اُردُو', country: 'Pakistan', flag: 'PK' },
  { value: 'hi', name: 'हिन्दी', country: 'India', flag: 'IN' }
];

export const COUNTRIES = [
  {
    name: 'United Arab Emirates',
    code: 'AE',
    continent: 'Asia',
    continent_code: 'AS',
    timezone: 'UTC+04:00',
    timezone_id: 'Asia/Dubai',
    phone_code: '+971'
  }
  // {
  //   name: 'Pakistan',
  //   code: 'PK',
  //   continent: 'Asia',
  //   continent_code: 'AS',
  //   timezone: 'UTC+05:00',
  //   timezone_id: 'Asia/Karachi',
  //   phone_code: '+92'
  // }
];

export const CITIES = [
  {
    name: 'Dubai',
    code: 'Dubai',
    continent: 'Asia',
    continent_code: 'AS',
    timezone: 'UTC+04:00',
    timezone_id: 'Asia/Dubai'
  }
];

export const CURRENCIES = [
  // {
  //   name: 'US Dollar',
  //   code: 'USD'
  // },
  // {
  //   name: 'Pakistani Rupee',
  //   code: 'PKR'
  // },
  {
    name: 'United Arab Emirates Dirham',
    code: 'AED'
  }
];

export const UNITS = [
  { name: 'Eaches', value: 'eaches' },
  { name: 'Gram (g)', value: 'g' },
  // { name: 'Gram (g)', value: 'gms' },
  { name: 'Kilogram (kg)', value: 'kg' },
  { name: 'Milligram (mg)', value: 'mg' },
  { name: 'Ounce (oz)', value: 'oz' },
  { name: 'Pound (lb)', value: 'lb' },
  { name: 'Milliliter (mL)', value: 'mL' },
  { name: 'Liter (L)', value: 'L' },
  { name: 'Centiliter (cL)', value: 'cL' },
  { name: 'Fluid ounce (fl oz)', value: 'fl oz' },
  { name: 'Pint (pt)', value: 'pt' },
  { name: 'Quart (qt)', value: 'qt' },
  { name: 'Gallon (gal)', value: 'gal' },
  { name: 'Each (ea)', value: 'ea' },
  { name: 'Dozen', value: 'dozen' },
  { name: 'Pack', value: 'pack' },
  { name: 'Case', value: 'case' },
  { name: 'Bundle', value: 'bundle' },
  { name: 'Inch (in)', value: 'in' },
  { name: 'Centimeter (cm)', value: 'cm' }
  // { name: 'Foot (ft)', value: 'ft' },
  // { name: 'Meter (m)', value: 'm' },
  // { name: 'Square inch (in²)', value: 'in²' },
  // { name: 'Square centimeter (cm²)', value: 'cm²' },
  // { name: 'Square foot (ft²)', value: 'ft²' },
  // { name: 'Square meter (m²)', value: 'm²' },
  // { name: 'Celsius (°C)', value: '°C' },
  // { name: 'Fahrenheit (°F)', value: '°F' },
  // { name: 'Per unit', value: 'per unit' },
  // { name: 'Per weight', value: 'per weight' },
  // { name: 'Per volume', value: 'per volume' },
  // { name: 'Per area', value: 'per area' }
];
